Vue.component('ReportIndexComponent', require('./components/ReportIndexComponent').default);
Vue.component('TrackerReportIndexComponent', require('./components/TrackerReportIndexComponent').default);
Vue.component('ReportChartComponent', require('./components/partials/ReportChartComponent').default);
Vue.component('ReportChartsComponent', require('./components/partials/ReportChartsComponent').default);
Vue.component('ReportSummaryComponent', require('./components/partials/ReportSummaryComponent').default);
Vue.component('ReportDataTableComponent', require('./components/partials/ReportDataTableComponent').default);
Vue.component(
    'ReportPatientsDataTableComponent',
    require('./components/partials/ReportPatientsDataTableComponent').default
);
Vue.component('ReportBlockedComponent', require('./components/partials/ReportBlockedComponent').default);
Vue.component('ReportNeqasOverdueComponent', require('./components/partials/ReportNeqasOverdueComponent').default);

Vue.component('TrackersTabsComponent', require('./components/partials/TrackersTabsComponent').default);
Vue.component('MhbuReportsComponent', require('./components/partials/MhbuReportsComponent').default);
Vue.component('MhbuReportsListModal', require('./components/partials/MhbuReportsListModal').default);
Vue.component('ReChallengedDataTable', require('./components/partials/ReChallengedDataTable').default);
Vue.component('AmberResultsDataTable', require('./components/partials/AmberResultsDataTable').default);
Vue.component('RedResultsDataTable', require('./components/partials/RedResultsDataTable').default);
Vue.component('TrackersReportsListModal', require('./components/partials/TrackersReportsListModal').default);
